export const pricingPlans = [
  {
    id: 1,
    name: "Essential",
    price: "$49",
    federal: "+ USPTO Filing Fee",
    recommended: false,
    features: [
      "Complete case evaluation",
      "Full USPTO application filing",
      "Preliminary trademark search",
      "State e-filing included",
      "Email progress notifications"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Get Started"
  },
  {
    id: 2,
    name: "Professional",
    price: "$199",
    federal: "+ USPTO Filing Fee",
    recommended: true,
    features: [
      "Everything in Essential",
      "In-depth conflict analysis",
      "Real-time monitoring alerts",
      "Refusal risk assessment",
      "Priority attorney access",
      "Live tracking dashboard"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Choose Professional"
  },
  {
    id: 3,
    name: "Enterprise",
    price: "$399",
    federal: "+ USPTO Filing Fee",
    recommended: false,
    features: [
      "Everything in Professional",
      "Comprehensive clearance report",
      "Senior case manager assigned",
      "Office action legal response",
      "Cease & desist letter drafting",
      "Multi-class filing support",
      "Direct attorney hotline"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Choose Enterprise"
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Brand Name Search",
    description: "We scan USPTO records, state filings, and common law databases to verify your brand name is available and assess its strength before filing."
  },
  {
    id: 2,
    step: "02",
    title: "Brand Name Filing",
    description: "Our attorneys prepare and submit your brand name trademark application to the USPTO with precise classification and complete documentation."
  },
  {
    id: 3,
    step: "03",
    title: "Track & Defend",
    description: "We monitor every milestone of your brand name application, tackle office actions, and keep you updated until your registration certificate arrives."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Bar-Admitted Attorneys",
    description: "Every filing is handled by licensed trademark attorneys with deep expertise in USPTO rules and federal IP statutes."
  },
  {
    id: 2,
    title: "One Price, Zero Surprises",
    description: "Packages start at $49 with everything spelled out. No add-on fees, no hidden charges, no fine print."
  },
  {
    id: 3,
    title: "Filed in Under 48 Hours",
    description: "Submit your details and we prepare, review, and file your application within two business days."
  },
  {
    id: 4,
    title: "Your Own Case Specialist",
    description: "A dedicated point of contact guides you from search to certificate with real-time status updates."
  },
  {
    id: 5,
    title: "Office Action Defense",
    description: "If the USPTO pushes back, our attorneys draft targeted legal responses to keep your application moving forward."
  },
  {
    id: 6,
    title: "Coast-to-Coast Coverage",
    description: "Federal registration locks in exclusive brand rights across all 50 states, enforceable in every U.S. court."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "E-commerce Founder",
    content: "Trademarking Company Name helped me register my brand name before a competitor could grab it. Zero office actions, zero stress. They know brand name protection inside out.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Tech Startup CEO",
    content: "Their brand name search caught a near-identical name I had no idea existed. If I had filed on my own, I'd be facing a rebrand. They saved my business identity.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    role: "Online Retailer",
    content: "The Professional package was worth every dollar for my brand name registration. From the deep search to the final certificate, every step was handled with precision.",
    rating: 5
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Product Designer",
    content: "I needed my brand name protected federally before launching nationwide. Their team filed everything correctly the first time and I had my certificate in 10 months.",
    rating: 5
  },
  {
    id: 5,
    name: "Amanda Stevens",
    role: "Small Business Owner",
    content: "Registering my brand name gave my company instant credibility with wholesale buyers. The flat-rate pricing and expert attorney support made the decision easy.",
    rating: 5
  },
  {
    id: 6,
    name: "Robert Wilson",
    role: "Brand Strategist",
    content: "I send every client here to get their brand names registered. The Essential package at $49 is the best deal in the industry for professional brand name filing.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is brand name trademark registration?",
    answer: "Brand name trademark registration is the legal process of securing exclusive federal rights to your business name through the U.S. Patent and Trademark Office. It gives you legal ownership of your brand name across all 50 states, the right to use the registered symbol, and access to federal courts if someone uses your name without permission."
  },
  {
    id: 2,
    question: "How long does it take to register my brand name?",
    answer: "The full brand name registration timeline runs 8 to 12 months on average. The USPTO begins examining your brand name about 3 to 4 months after filing. If approved, your name enters a 30-day opposition window before the certificate issues. Our team handles every office action quickly to avoid delays."
  },
  {
    id: 3,
    question: "What does the $49 Essential brand name package include?",
    answer: "Essential covers a full brand name evaluation, complete USPTO application filing, preliminary name availability search, and state e-filing. It works well for straightforward brand names with low conflict risk. The USPTO government fee ($250 to $350 per class) is paid separately."
  },
  {
    id: 4,
    question: "Which package is best for brand name registration?",
    answer: "Essential is right for simple, low-risk brand name filings. Professional adds an in-depth name conflict search, monitoring, risk assessment, and priority attorney access. Enterprise includes everything plus a senior case manager, office action defense, cease-and-desist drafting, and multi-class support."
  },
  {
    id: 5,
    question: "Do I need a brand name search before filing?",
    answer: "We strongly recommend it. A thorough brand name search examines the USPTO database, state registrations, and common law usage to uncover existing names that could block your application. Skipping this step risks rejection. Professional and Enterprise packages include a comprehensive search."
  },
  {
    id: 6,
    question: "Can I register my brand name if it is already in use?",
    answer: "It depends. If someone else has already registered the same or a confusingly similar brand name in your industry class, your application may be refused. Our attorneys conduct a thorough search during consultation to assess the availability and strength of your brand name before filing."
  },
  {
    id: 7,
    question: "What happens if the USPTO refuses my brand name?",
    answer: "Our attorneys analyze the specific objection to your brand name, build a strategic legal response, and file it within the required deadline. Enterprise clients get this at no extra charge. For other packages, office action response is available as an add-on."
  },
  {
    id: 8,
    question: "State vs. federal brand name registration -- what is the difference?",
    answer: "State registration only covers your brand name in one state. Federal USPTO registration protects your brand name across all 50 states, allows use of the registered symbol, lists you in the national database, and opens the door to federal court enforcement. For any brand name with growth ambitions, federal is the way to go."
  },
  {
    id: 9,
    question: "Can I register a brand name as an individual?",
    answer: "Absolutely. Individuals can register brand names with the USPTO. You do not need an LLC, corporation, or any other business entity. The key requirement is that the brand name is used in commerce or you have a genuine intent to use it."
  },
  {
    id: 10,
    question: "What are the government fees for brand name registration?",
    answer: "USPTO filing fees run $250 to $350 per class and are paid directly to the government on top of our service fee. These are non-refundable. During your consultation, we identify the right classes for your brand name and walk you through the payment process."
  }
];

export const successStories = [
  {
    id: 1,
    client: "NovaBrew Coffee",
    industry: "Food & Beverage",
    result: "Brand name secured in 9 months",
    quote: "We trademarked our brand name right before a competitor tried to use it. Having the registered symbol next to NovaBrew on every product changed how retailers perceived us.",
    image: "https://images.unsplash.com/photo-1758598497628-942ad38a6dc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxjb25maWRlbnQlMjBidXNpbmVzcyUyMG93bmVyJTIwb2ZmaWNlfGVufDB8fHx8MTc3NjE5ODMwOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    client: "UrbanFit Apparel",
    industry: "Fashion & Retail",
    result: "Blocked 3 counterfeit sellers using their name",
    quote: "Within weeks of getting our brand name trademarked, we removed three counterfeiters from Amazon who were selling under the UrbanFit name. The ROI was immediate.",
    image: "https://images.unsplash.com/photo-1758598306980-c47a94c6708c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxjb25maWRlbnQlMjBidXNpbmVzcyUyMG93bmVyJTIwb2ZmaWNlfGVufDB8fHx8MTc3NjE5ODMwOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    client: "ByteShield Security",
    industry: "Technology",
    result: "Brand name approved with zero office actions",
    quote: "Their pre-filing brand name search was so thorough that our application sailed through the USPTO without a single objection. Worth every penny.",
    image: "https://images.unsplash.com/photo-1758519290890-46b542bb25fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxjb25maWRlbnQlMjBidXNpbmVzcyUyMG93bmVyJTIwb2ZmaWNlfGVufDB8fHx8MTc3NjE5ODMwOHww&ixlib=rb-4.1.0&q=85"
  }
];

export const countryCodes = [
  { code: '+1', country: 'US/Canada', flag: '\u{1f1fa}\u{1f1f8}' },
  { code: '+44', country: 'UK', flag: '\u{1f1ec}\u{1f1e7}' },
  { code: '+91', country: 'India', flag: '\u{1f1ee}\u{1f1f3}' },
  { code: '+86', country: 'China', flag: '\u{1f1e8}\u{1f1f3}' },
  { code: '+81', country: 'Japan', flag: '\u{1f1ef}\u{1f1f5}' },
  { code: '+49', country: 'Germany', flag: '\u{1f1e9}\u{1f1ea}' },
  { code: '+33', country: 'France', flag: '\u{1f1eb}\u{1f1f7}' },
  { code: '+39', country: 'Italy', flag: '\u{1f1ee}\u{1f1f9}' },
  { code: '+61', country: 'Australia', flag: '\u{1f1e6}\u{1f1fa}' },
  { code: '+55', country: 'Brazil', flag: '\u{1f1e7}\u{1f1f7}' },
  { code: '+52', country: 'Mexico', flag: '\u{1f1f2}\u{1f1fd}' },
  { code: '+7', country: 'Russia', flag: '\u{1f1f7}\u{1f1fa}' },
  { code: '+82', country: 'South Korea', flag: '\u{1f1f0}\u{1f1f7}' },
  { code: '+34', country: 'Spain', flag: '\u{1f1ea}\u{1f1f8}' },
  { code: '+31', country: 'Netherlands', flag: '\u{1f1f3}\u{1f1f1}' },
  { code: '+46', country: 'Sweden', flag: '\u{1f1f8}\u{1f1ea}' },
  { code: '+47', country: 'Norway', flag: '\u{1f1f3}\u{1f1f4}' },
  { code: '+41', country: 'Switzerland', flag: '\u{1f1e8}\u{1f1ed}' },
  { code: '+65', country: 'Singapore', flag: '\u{1f1f8}\u{1f1ec}' },
  { code: '+971', country: 'UAE', flag: '\u{1f1e6}\u{1f1ea}' },
  { code: '+966', country: 'Saudi Arabia', flag: '\u{1f1f8}\u{1f1e6}' },
  { code: '+27', country: 'South Africa', flag: '\u{1f1ff}\u{1f1e6}' },
  { code: '+64', country: 'New Zealand', flag: '\u{1f1f3}\u{1f1ff}' },
  { code: '+351', country: 'Portugal', flag: '\u{1f1f5}\u{1f1f9}' },
  { code: '+48', country: 'Poland', flag: '\u{1f1f5}\u{1f1f1}' },
  { code: '+20', country: 'Egypt', flag: '\u{1f1ea}\u{1f1ec}' },
  { code: '+90', country: 'Turkey', flag: '\u{1f1f9}\u{1f1f7}' },
  { code: '+62', country: 'Indonesia', flag: '\u{1f1ee}\u{1f1e9}' },
  { code: '+63', country: 'Philippines', flag: '\u{1f1f5}\u{1f1ed}' },
  { code: '+66', country: 'Thailand', flag: '\u{1f1f9}\u{1f1ed}' },
  { code: '+60', country: 'Malaysia', flag: '\u{1f1f2}\u{1f1fe}' },
  { code: '+84', country: 'Vietnam', flag: '\u{1f1fb}\u{1f1f3}' },
  { code: '+92', country: 'Pakistan', flag: '\u{1f1f5}\u{1f1f0}' },
  { code: '+880', country: 'Bangladesh', flag: '\u{1f1e7}\u{1f1e9}' },
  { code: '+94', country: 'Sri Lanka', flag: '\u{1f1f1}\u{1f1f0}' },
  { code: '+977', country: 'Nepal', flag: '\u{1f1f3}\u{1f1f5}' },
  { code: '+234', country: 'Nigeria', flag: '\u{1f1f3}\u{1f1ec}' },
  { code: '+254', country: 'Kenya', flag: '\u{1f1f0}\u{1f1ea}' },
  { code: '+233', country: 'Ghana', flag: '\u{1f1ec}\u{1f1ed}' },
  { code: '+212', country: 'Morocco', flag: '\u{1f1f2}\u{1f1e6}' },
  { code: '+353', country: 'Ireland', flag: '\u{1f1ee}\u{1f1ea}' },
  { code: '+43', country: 'Austria', flag: '\u{1f1e6}\u{1f1f9}' },
  { code: '+32', country: 'Belgium', flag: '\u{1f1e7}\u{1f1ea}' },
  { code: '+45', country: 'Denmark', flag: '\u{1f1e9}\u{1f1f0}' },
  { code: '+358', country: 'Finland', flag: '\u{1f1eb}\u{1f1ee}' },
  { code: '+30', country: 'Greece', flag: '\u{1f1ec}\u{1f1f7}' },
  { code: '+972', country: 'Israel', flag: '\u{1f1ee}\u{1f1f1}' },
  { code: '+56', country: 'Chile', flag: '\u{1f1e8}\u{1f1f1}' },
  { code: '+57', country: 'Colombia', flag: '\u{1f1e8}\u{1f1f4}' },
  { code: '+54', country: 'Argentina', flag: '\u{1f1e6}\u{1f1f7}' },
  { code: '+974', country: 'Qatar', flag: '\u{1f1f6}\u{1f1e6}' },
  { code: '+965', country: 'Kuwait', flag: '\u{1f1f0}\u{1f1fc}' },
  { code: '+852', country: 'Hong Kong', flag: '\u{1f1ed}\u{1f1f0}' },
  { code: '+886', country: 'Taiwan', flag: '\u{1f1f9}\u{1f1fc}' },
];
